import api from "@utils/api";

export const assignPlaceToUser = (userToPlace) => api.post(`/user_place`, userToPlace);
export const getUserPlaces = () => api.get(`/user_place`);
export const removePlaceFromUser = (idUser, idPlace) => api.delete(`/user_place/${idUser}/${idPlace}`);